import React from 'react';
import { useTranslation } from 'react-i18next';

import { fileIcon } from 'assets/images';

import styles from './style.module.scss';

const DocumentCard = ({ documentUrl }) => {
  const { t } = useTranslation('global');

  return (
    <div className={styles.container}>
      <img src={fileIcon} alt="fileIcon" />
      <div className={styles.fileContainer}>
        <a
          href={documentUrl}
          target="_blank"
          rel="noopener noreferrer"
          download>
          <p className={styles.title}>{t('documentation')}</p>
          <p className={styles.subtitle}>PDF</p>
        </a>
      </div>
    </div>
  );
};

export default DocumentCard;
